import React, { useEffect, useMemo, useState } from 'react';
import FutureOdds from './Futures/FutureOdds';
import { useSearchParams } from 'react-router-dom';
import { selectFutures, selectSearch, setFutures } from '../homeSlice';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import axios, { CancelTokenSource } from 'axios';
import { resetLoading, setLoading } from 'redux/userSlice';
import futureApi from 'api/futureApi';

interface FutureTabContentProps {}

const FutureTabContent: React.FunctionComponent<FutureTabContentProps> = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const futures = useAppSelector(selectFutures);
  const search = useAppSelector(selectSearch);
  const [cancelTokenSource, setCancelTokenSource] = useState<CancelTokenSource | null>(null);
  const tab = useMemo((): string | null => {
    return searchParams.get('category');
  }, [searchParams]);
  const fetchFutureOdds = async () => {
    const source = axios.CancelToken.source();
    setCancelTokenSource(source);
    dispatch(setLoading());
    const { ok, body } = await futureApi.getFutures(
      {
        'sport.in': search.isSearchLayout ? '' : tab || 'Football',
        'enable.equals': true,
        size: 10000,
      },
      source.token,
    );
    dispatch(resetLoading());
    if (ok && body) {
      dispatch(setFutures(body));
    }
  };

  useEffect(() => {
    dispatch(setFutures(undefined));
    if (cancelTokenSource) {
      cancelTokenSource.cancel('Request canceled due to new tab');
    }
    fetchFutureOdds();
  }, [tab, search]);

  useEffect(() => {
    const idInterval = setInterval(() => {
      fetchFutureOdds();
    }, 60000);
    return () => {
      clearInterval(idInterval);
    };
  }, [tab, search, futures]);

  return (
    <div className="future-tab-content">
      {futures?.map(
        (future) => future.futureOdds.length > 0 && <FutureOdds key={future.id} future={future} />,
      )}
    </div>
  );
};

export default FutureTabContent;
